var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c(_vm.layout,{tag:"component"}),_c('loading',{attrs:{"loader":"dots","color":"#994e52","opacity":_vm.opacity,"active":_vm.isLoading,"is-full-page":""},on:{"update:active":function($event){_vm.isLoading=$event}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }